<template>
  <el-container style="height:100%">
    <el-header>
      <div class="logo-container">
        <!--        <img src="../assets/images/logo.png"/>-->
        <img class="logo" src="../assets/images/logo7.png" />
        <!-- <span class="system-title">昭可中日通</span> -->
      </div>
      <div style="display:flex;width: 100%;justify-content: space-between;">
        <div class="toggle-button" @click="toggleCollapse"><span
            :class="{ 'el-icon-d-arrow-left': !isCollapse, 'el-icon-d-arrow-right': isCollapse }"></span></div>
        <div class="header-right-contaienr float-right overflow">
          <div class="float">
            <span class="el-dropdown-link">
              <el-badge is-dot v-if="btnReadFlag == 1"></el-badge>
              <el-link :underline="false" class="el-icon-message-solid" style="font-size:20px" @click="inbox">
              </el-link>
            </span>
          </div>
          <div class="float">
            <el-dropdown class="padding5">
              <span class="el-dropdown-link userName">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <el-link type="info" @click="logout" :underline="false">退出</el-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

    </el-header>

    <el-container>
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <el-menu router background-color="#333744" text-color="#fff" active-text-color="#409EFF" unique-opened
          :collapse="isCollapse" :collapse-transition="false" :default-active="$route.path">
          <template v-for="item in menulist">
            <el-menu-item :index="'/' + item.menuUrl" :key="item.menuId"
              v-if="!item.menuTreeClild || item.menuTreeClild.length < 1">
              <i :class="item.menuIcon"></i>
              <span>{{ item.menuName }}</span>
            </el-menu-item>
            <el-submenu class="zcl-add" :index="item.menuId + ''" :key="item.menuId" v-else>
              <template slot="title">
                <i :class="item.menuIcon"></i>
                <el-badge
                  is-dot
                  class="item"
                  v-if="item.menuName === '消息管理' && (num > 0)"
                >
                  {{ item.menuName }}
                </el-badge>
                <span v-else>{{ item.menuName }}</span>
              </template>
              <el-menu-item class="zcl-add-two" :index="'/' + subItem.menuUrl" v-for="subItem in item.menuTreeClild" :key="subItem.menuId">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <el-badge :value="num" class="item" v-if="subItem.menuName === '收件箱' && num > 0">
                    {{ subItem.menuName }}
                  </el-badge>
                  <span v-else>{{ subItem.menuName }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </el-aside>

      <el-main>
        <div class="fixed-header" :class="{ 'fixed-header-shou': isCollapse }">
          <tags-view></tags-view>
        </div>
        <!--面包屑-->
        <el-breadcrumb class="breadcrumb" separator="/">
          <!--默认给一个首页的跳转，如果不需要可以去掉-->
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <!--面包屑列表-->
          <el-breadcrumb-item v-for='(item, index) in breadList' :key='index' @click.native="breadcrumbClick(item)"
            style="cursor: pointer">
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <keep-alive
          :include="['orders', 'container', 'orderIncome', 'access', 'income', 'batchIncome', 'arrivalOrders', 'storageOrders', 'badOrder']">
          <router-view></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import TagsView from "./layout/components/TagsView/index";

export default {
  components: {
    TagsView,
  },
  data() {
    return {
      menulist: [],
      breadList: [],
      // iconObj: {
      //   "1": "iconfont icon-icon_user",
      //   "2": "iconfont icon-tijikongjian",
      //   "11": "iconfont icon-shangpin",
      //   "21": "iconfont icon-danju",
      //   "22": "iconfont icon-baobiao"
      // },
      isCollapse: false,
      unReadCount: 0,
      btnReadFlag: 0,
      count: 0,
      timer: '',
      value: 0,
      username: ''
    };
  },
  methods: {
    // 面包屑点击事件
    breadcrumbClick(item) {
      this.$router.push({
        path: item.path
      })
    },
    // 面包屑数据处理
    getBreadcrumb() {
      let that = this;
      // 由于本项目大部分属于‘一级’页面，所以在设置路由时候，一级页面不设置breadNumber = 1，‘二级’页面以上才设置breadNumber
      let breadNumber = typeof (this.$route.meta.breadNumber) !== 'undefined' ? this.$route.meta.breadNumber : 1;
      // 获取当前页面的名字和路由，并组合成新的对象
      let newBread = { name: this.$route.meta.title, path: this.$route.fullPath };
      let vuexBreadList = []; // 默认初始化面包屑数据
      if (breadNumber !== 1) {
        // 当前面包屑breadNumber大于1时才会从vuex中获取值
        vuexBreadList = that.$store.state.breadListState; // 获取breadList数组
      }
      if (breadNumber < vuexBreadList.length) {
        // "回退"面包屑----判断条件：当前路由breadNumber小于vuexBreadList的长度
        vuexBreadList.splice(breadNumber - vuexBreadList.length, vuexBreadList.length - breadNumber);
      }
      if (breadNumber > vuexBreadList.length) {
        // 添加面包屑----判断条件：当前路由breadNumber大于vuexBreadList的长度
        vuexBreadList.push(newBread);
      }
      // 处理完数据后，将最终的数据更新到vuex（用于页面刷新）
      that.$store.commit('breadListMutations', vuexBreadList);
      // 处理完数据后，将最终的数据更新为新的面包屑数组
      that.breadList = vuexBreadList;
    },
    logout() {
      window.sessionStorage.clear;
      this.$router.push("/login");
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    async getMenuList() {
      const { data: res } = await this.$http.get('admin/info');
      this.menulist = res.data.menus;
      window.sessionStorage.setItem('permissionList', JSON.stringify(res.data.permissionList));
      //用户名放入session
      window.sessionStorage.setItem('username', res.data.username);
      this.username = sessionStorage.getItem('username');

      const resTag = await this.$http.get('cms/inBox/messageCount');
      let num = resTag?.data?.data?.notReplyCount || 0
      this.$store.commit('setMessageUnread', num);
    },
    setringItemClick(command) {
      if (command == "item1") {
        this.$router.push("/personalData");
      } else if (command == "item2") {
        this.$router.push("/accountSecurity");
      }
    },
    inbox() {
      // window.sessionStorage.clear;
      this.$router.push({
        name: 'inBox'
      });
    },
    async getUnReadCount() {
      const { data: res } = await this.$http.get('cms/inBox/unReadCount', {});
      // console.log("data："+res.data);
      // console.log("content："+res);
      this.count = res.data;
      if (res.data == 0) {
        this.btnReadFlag = 0;  //=1展示
      } else {
        this.btnReadFlag = 1;   //=0不展示
      }
      // console.log("unReadCount:"+this.btnReadFlag);
      // console.log(this.value++);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  created() {
    console.log(this.$store.state.messageUnread)
    this.getUnReadCount();
    this.timer = setInterval(() => {
      this.getUnReadCount();
    }, 10000);
    this.getMenuList();
    //console.log(this.$route.path);
    //console.log('-0-------')
    // this.menulist = [
    //   {
    //     id: 1,
    //     // order: 1,
    //     path: "orders",
    //     authName: "用户管理",
    //     children: [
    //       {
    //         id: 10,
    //         authName: "用户列表",
    //         path: "orders",
    //         children: [],
    //         // order: null
    //       }
    //     ],

    //   },
    //   {
    //     id: 2,
    //     // order: null,
    //     path: "rights",
    //     authName: "权限列表",
    //     children: [{
    //       id: 21,
    //       // order: null,
    //       path: "roles",
    //       authName: "角色列表",
    //       children: []
    //     },
    //     {
    //       id: 22,
    //       // order: null,
    //       path: "rights",
    //       authName: "权限列表",
    //       children: [],

    //     }
    //     ]
    //   }
    // ]
  },
  watch: {
    // 监听路由的变化
    $route() {
      this.getBreadcrumb();
    }
  },
  computed: {
    num(){
      return this.$store.state.messageUnread
    }
  }

};
</script>

<style lang="less" scoped>
.logo {
  width: 180px;
  height: 40px;
}

.breadcrumb {
  width: 100%;
  //margin-top:10px;
  display: block;
}

.el-link.el-link--default {
  color: #fff !important;
}

.el-header {
  height: 50px !important;
  line-height: 50px !important;
  background-color: #3e8ef7;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;

  >div {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: bold;

    span {
      margin-left: 15px;
    }
  }
}

.el-aside {
  background-color: #3a4255;

  .el-menu {
    border-right: none;
  }
}

.el-main {
  overflow: hidden;
  background-color: #eaedf1;
  padding: 45px 15px 15px 15px !important;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}

.system-title {
  font-size: 20px;
}

.header-right-contaienr {
  padding: 0;
}

.el-dropdown {
  color: #fff;
}

/deep/.el-badge__content {
  border: none !important;
}

/deep/ .el-submenu__title,
.el-menu,
.el-menu-item {
  background-color: #3a4255 !important;
}

/deep/ .el-submenu__title:focus,
.el-submenu__title:active,
.el-menu:focus,
.el-menu:active,
.el-menu-item:focus,
.el-menu-item:active {
  background-color: #0c0b0b !important;
  color: #fff !important;
}

.el-menu-item.is-active {
  background-color: #3e8ef7 !important;
  color: #fff !important;
}

/deep/ .el-submenu__title:hover,
.el-menu:hover,
.el-menu-item:hover {
  background-color: #4a505f !important;
  color: #fff !important;
}

.logo-container {
  width: 219px;
  height: 64px;
  background-color: #3e8ef7;
  padding: 30px 0px 30px 15px;
  // img {
  //   width: 174px;
  //   height: 32px;
  // }
}

// 自定义滚动条
.el-aside {
  overflow: auto;
  position: relative;
}

.el-aside::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.el-aside::-webkit-scrollbar-track {
  border-radius: 15px;
  overflow: hidden;
}

.el-aside::-webkit-scrollbar-thumb {
  background: #0c0b0b;
}

.el-dropdown-link,
.el-dropdown-link a,
.userName {
  display: inline-block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  border: none;
}

.el-dropdown-link,
.userName {
  padding: 0 10px;
}

.el-dropdown-link:hover {
  background-color: #0c0b0b !important;
  cursor: pointer;
}

.userName:hover {
  background-color: #0c0b0b !important;
}

.el-dropdown-link {
  position: relative;
  margin-left: 0 !important;
}

/deep/.el-badge {
  position: absolute;
  top: 0;
  left: 5px;
}

/deep/.el-badge__content {
  border: none !important;
}

.fixed-header {
  position: fixed;
  top: 50px;
  right: 0;
  width: calc(100% - 200px);
  z-index: 9;
  transition: width 0.28s;
}

.fixed-header-shou {
  width: calc(100% - 65px);
}
.zcl-add{
  /deep/ .el-badge {
    position: relative;
    left: 5px;
  }
  /deep/ .el-badge__content.is-fixed.is-dot {
    right: -5px;
    top: 15px;
  }
}
.zcl-add-two{
  /deep/ .el-badge__content.is-fixed {
    top: 15px;
    right: -5px;
  }
}
</style>
